import { exec, getApiToken } from '@src/apis/reware/utils';
import type { SftpFolderContents } from './types';

export interface FetchSftpFolderContentsArgs {
  partnerCode: string;
  token: string;
  entry: string;
  path?: string;
}

interface FetchSftpFolderContentsExecVariables {
  token: string;
  partnerCode: string;
  entry: string;
  path?: string;
}

interface FetchSftpFolderContentsExecResponse {
  restUser: {
    partner: {
      sftpFolderContents: SftpFolderContents;
    };
  };
}

/** Fetches the sub-folders and files under a partner SFTP folder entry. */
export const fetchSftpFolderContents = async (
  { partnerCode, token, entry, path }: FetchSftpFolderContentsArgs
): Promise<SftpFolderContents> => {
  const apiToken = await getApiToken(token);

  const query = `
    query getSftpFolderContents(
      $token: String!
      $partnerCode: String!
      $entry: String!
      $path: String
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          sftpFolderContents(entry: $entry, path: $path) {
            folders
            files {
              name
              path
              size
              lastModified
            }
          }
        }
      }
    }
  `;

  const data = await exec<FetchSftpFolderContentsExecVariables, FetchSftpFolderContentsExecResponse>(
    query,
    {
      variables: {
        token: apiToken,
        partnerCode,
        entry,
        path,
      },
    }
  );

  return data.restUser.partner.sftpFolderContents;
};
